import {
	Box,
	Button,
	FormControlLabel,
	Switch,
	useMediaQuery,
	Paper,
	Typography,
	Divider
} from '@mui/material';
import { makeStyles } from '@mui/styles';
import React, { useState } from 'react';
import OwnerRoomDialog from './owner.room.dialog';
import ToggleChat from "../dashboard/dashboard.toggle.chat";
import ToggleOrder from "../room/owner.room.orderEnabled";
import SettingsIcon from '@mui/icons-material/Settings';
import MeetingRoomIcon from '@mui/icons-material/MeetingRoom';

const useStyles = makeStyles((theme) => ({
	rootPaper: {
		padding: theme.spacing(2),
		borderRadius: '16px !important',
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'space-between',
		flexWrap: 'wrap',
		gap: '20px',
		backgroundColor: `${theme.palette.background.paper}`,
		boxShadow: '0px 4px 20px rgba(0,0,0,0.08) !important',

		[theme.breakpoints.down('sm')]: {
			justifyContent: 'center',
			padding: '8px !important', // Padding molto ridotto
			// Usiamo rowGap e columnGap separati per avere controllo totale
			rowGap: '4px',    // Spazio minimo tra le righe (sopra e sotto le sale)
			columnGap: '8px', // Spazio tra elementi sulla stessa riga
			borderRadius: '12px !important',
		}
	},
	section: {
		display: 'flex',
		alignItems: 'center',
		gap: '12px',
		[theme.breakpoints.down('sm')]: {
			// Se non ci sono bottoni visibili, riduciamo l'altezza a zero
			width: '100%',
			justifyContent: 'center',
			gap: '8px',
			// Rimuove lo spazio occupato dalla sezione "Gestione" se i bottoni sono nascosti
			'&:empty': { display: 'none' }
		}
	},
	roomGroup: {
		backgroundColor: theme.palette.action.hover,
		borderRadius: '12px',
		padding: '4px',
		display: 'flex',
		gap: '4px',
		flexWrap: 'wrap',
		justifyContent: 'center',
		[theme.breakpoints.down('sm')]: {
			padding: '2px', // Ancora più sottile il bordo grigio
		}
	},
	roomButton: {
		borderRadius: '8px !important',
		textTransform: 'none !important',
		fontWeight: '600 !important',
		border: 'none !important',
		transition: 'all 0.2s ease-in-out !important',
		[theme.breakpoints.down('sm')]: {
			padding: '4px 8px !important', // Bottoni sale più bassi
			fontSize: '0.85rem !important',
		}
	},
	togglesContainer: {
		display: 'flex',
		alignItems: 'center',
		gap: '10px',
		padding: '8px 16px',
		borderRadius: '12px',
		backgroundColor: theme.palette.background.default,
		[theme.breakpoints.down('sm')]: {
			width: 'auto',       // Non forziamo il 100% se non serve
			marginTop: '4px',    // Margine ridotto tra sale e toggle
			padding: '4px 12px', // Più compatto internamente
		}
	}
}));

export default function OwnerRoomButtonBar({
	rooms,
	setRooms,
	setCurrentRoom,
	currentRoom,
	setTables,
	isLocked,
	setIsLocked,
}) {
	const classes = useStyles();
	const [open, setOpen] = useState(false);
	const isMobile = useMediaQuery("(max-width:576px)");

	const updateCurrentRoom = (id) => {
		if (id === currentRoom) return;
		setTables([]);
		setCurrentRoom(id);
	};

	return (
		<Paper className={classes.rootPaper} elevation={0}>
			{/* SINISTRA: Azioni Gestione */}
			{!isMobile && (
				<Box className={classes.section}>
					<Button
						className={classes.manageButton}
						variant='outlined'
						color='primary'
						startIcon={<SettingsIcon />}
						onClick={() => setOpen(true)}
					>
						Gestisci sale
					</Button>

					<FormControlLabel
						control={
							<Switch
								checked={!isLocked}
								onChange={(e) => setIsLocked(!e.target.checked)}
								color="primary"
							/>
						}
						label={
							<Typography variant="body2" sx={{ fontWeight: 600 }}>
								Modifica mappa
							</Typography>
						}
					/>
				</Box>
			)}

			{/* CENTRO: Selezione Sale */}
			<Box className={classes.section} sx={{ flexGrow: 1, justifyContent: 'center' }}>
				<Box className={classes.roomGroup}>
					{rooms && rooms.length > 0 ? (
						rooms.map(({ id, name }) => (
							<Button
								key={id}
								onClick={() => updateCurrentRoom(id)}
								className={classes.roomButton}
								variant={id === currentRoom ? 'contained' : 'text'}
								color={id === currentRoom ? 'primary' : 'inherit'}
								startIcon={id === currentRoom ? <MeetingRoomIcon /> : null}
							>
								{name}
							</Button>
						))
					) : (
						<Typography variant="caption" sx={{ p: 1 }}>Nessuna sala configurata</Typography>
					)}
				</Box>
			</Box>

			{/* DESTRA: Toggle Servizi */}
			<Box className={classes.togglesContainer}>
				<ToggleChat />
				<Divider orientation="vertical" flexItem sx={{ mx: 1 }} />
				<ToggleOrder />
			</Box>

			<OwnerRoomDialog
				rooms={rooms}
				setRooms={setRooms}
				open={open}
				setOpen={setOpen}
				setCurrentRoom={setCurrentRoom}
				currentRoom={currentRoom}
			/>
		</Paper>
	);
}